import { 
  Component, 
  OnInit,
  OnDestroy,
  OnChanges,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  Validators 
} from '@angular/forms';

import { isEqual, isNil } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil, mergeMap, shareReplay } from 'rxjs/operators';

import { DatexFormControl, validateControlOnChange, validateFormOnControlChange } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles,
  ValueControlModel
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { FieldsetModel } from './models/fieldset';
import { ToolModel } from './models/tool';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_integration_info_by_order_id_ComponentContextService } from './FootprintManager.integration_info_by_order_id.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'FootprintManager-integration_info_by_order_id',
  templateUrl: './FootprintManager.integration_info_by_order_id.component.html'
})
export class FootprintManager_integration_info_by_order_idComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {

  inParams: { order_id?: number } = { order_id: null };
  //#region Inputs
  @Input('order_id') set $inParams_order_id(v: number) {
    this.inParams.order_id = v;
  }
  get $inParams_order_id(): number {
    return this.inParams.order_id;
  }
  //#endregion Inputs

  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  //#endregion

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  vars: { outbound_transactions?: { transaction_id?: string, transmission_id?: number, entity?: string }[] } = { };
  //#endregion
  //#region Events
  
  //#endregion

  formGroup: FormGroup = new FormGroup({
    IntegrationHubId: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    IntegrationHubSourceId: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    IntegrationHubSourceLookupCode: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    IntegrationHubSourcePlatform: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    In_Type: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    In_CreatedSysDateTime: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    In_IntegrationId: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    In_TransactionId: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    In_Notes: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    In_Payload_Xml: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    In_Payload_Json: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    Out_Type: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    Out_CreatedSysDateTime: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    Out_IntegrationId: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    Out_TransactionId: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    Out_Notes: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    Out_Payload_Xml: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    Out_Payload_Json: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  get valid(): boolean {
    return this.formGroup.valid;
  }
  
  toolbar = {
  };

  fields = {
    IntegrationHubId: new FieldModel(new TextBoxModel(this.formGroup.controls['IntegrationHubId'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Integration hub ID', false, false),
    IntegrationHubSourceId: new FieldModel(new TextBoxModel(this.formGroup.controls['IntegrationHubSourceId'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Integration hub source ID', false, false),
    IntegrationHubSourceLookupCode: new FieldModel(new TextBoxModel(this.formGroup.controls['IntegrationHubSourceLookupCode'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Integration hub source lookup', false, false),
    IntegrationHubSourcePlatform: new FieldModel(new TextBoxModel(this.formGroup.controls['IntegrationHubSourcePlatform'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Integration hub source platform', false, false),
    In_Type: new FieldModel(new TextBoxModel(this.formGroup.controls['In_Type'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Type', false, false),
    In_CreatedSysDateTime: new FieldModel(new DateBoxModel(this.formGroup.controls['In_CreatedSysDateTime'] as DatexFormControl, null, false, false, '', 'datetime', null)
, new ControlContainerStyles(null, null), 'Created sys date time', false, false),
    In_IntegrationId: new FieldModel(new TextBoxModel(this.formGroup.controls['In_IntegrationId'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Integration ID', false, false),
    In_TransactionId: new FieldModel(new TextBoxModel(this.formGroup.controls['In_TransactionId'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Transaction ID', false, false),
    In_Notes: new FieldModel(new TextBoxModel(this.formGroup.controls['In_Notes'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Notes', false, false),
    In_Payload_Xml: new FieldModel( new CodeBoxModel(this.formGroup.controls['In_Payload_Xml'] as DatexFormControl, null, null, false, 'xml', null)
, new ControlContainerStyles(null, null), 'Xml payload', false, false),
    In_Payload_Json: new FieldModel( new CodeBoxModel(this.formGroup.controls['In_Payload_Json'] as DatexFormControl, null, null, false, 'json', null)
, new ControlContainerStyles(null, null), 'Json payload', false, false),
    Out_Type: new FieldModel(new TextBoxModel(this.formGroup.controls['Out_Type'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Type', false, false),
    Out_CreatedSysDateTime: new FieldModel(new DateBoxModel(this.formGroup.controls['Out_CreatedSysDateTime'] as DatexFormControl, null, false, false, '', 'datetime', null)
, new ControlContainerStyles(null, null), 'Created sys date time', false, false),
    Out_IntegrationId: new FieldModel(new TextBoxModel(this.formGroup.controls['Out_IntegrationId'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Integration ID', false, false),
    Out_TransactionId: new FieldModel(new TextBoxModel(this.formGroup.controls['Out_TransactionId'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Transaction ID', false, false),
    Out_Notes: new FieldModel(new TextBoxModel(this.formGroup.controls['Out_Notes'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Notes', false, false),
    Out_Payload_Xml: new FieldModel( new CodeBoxModel(this.formGroup.controls['Out_Payload_Xml'] as DatexFormControl, null, null, false, 'xml', null)
, new ControlContainerStyles(null, null), 'Xml payload', false, false),
    Out_Payload_Json: new FieldModel( new CodeBoxModel(this.formGroup.controls['Out_Payload_Json'] as DatexFormControl, null, null, false, 'json', null)
, new ControlContainerStyles(null, null), 'Json payload', false, false),
    Out_Delete: new FieldModel(new ButtonModel('', new ButtonStyles(['destructive'], null), false, false, false, 'Delete', 'icon-ic_fluent_delete_20_regular', null)
, new ControlContainerStyles(null, null), 'Deleting the transmission may re-trigger the export process.', false, false),
  };

  fieldsets = {
    integration_hub: new FieldsetModel(
      'Integration information',
      false,
      true,
      true,
      false,
        null
      ,
      () => {
        const $form = this;
        const $utils = this.$utils;
        return '';
      }
    ),
    inbound_transmission: new FieldsetModel(
      'Inbound transmission',
      false,
      true,
      true,
      false,
        null
      ,
      () => {
        const $form = this;
        const $utils = this.$utils;
        return '';
      }
    ),
    outbound_transmission: new FieldsetModel(
      'Outbound transmission',
      false,
      true,
      true,
      false,
        null
      ,
      () => {
        const $form = this;
        const $utils = this.$utils;
        return '';
      }
    ),
};

  //#region fields inParams
  //#endregion fields inParams

  $formGroupFieldValidationObservables = {
    IntegrationHubId: this.fields.IntegrationHubId.control.valueChanges
    ,
    IntegrationHubSourceId: this.fields.IntegrationHubSourceId.control.valueChanges
    ,
    IntegrationHubSourceLookupCode: this.fields.IntegrationHubSourceLookupCode.control.valueChanges
    ,
    IntegrationHubSourcePlatform: this.fields.IntegrationHubSourcePlatform.control.valueChanges
    ,
    In_Type: this.fields.In_Type.control.valueChanges
    ,
    In_CreatedSysDateTime: this.fields.In_CreatedSysDateTime.control.valueChanges
    ,
    In_IntegrationId: this.fields.In_IntegrationId.control.valueChanges
    ,
    In_TransactionId: this.fields.In_TransactionId.control.valueChanges
    ,
    In_Notes: this.fields.In_Notes.control.valueChanges
    ,
    Out_Type: this.fields.Out_Type.control.valueChanges
    ,
    Out_CreatedSysDateTime: this.fields.Out_CreatedSysDateTime.control.valueChanges
    ,
    Out_IntegrationId: this.fields.Out_IntegrationId.control.valueChanges
    ,
    Out_TransactionId: this.fields.Out_TransactionId.control.valueChanges
    ,
    Out_Notes: this.fields.Out_Notes.control.valueChanges
    ,
  }
  

  constructor(
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_integration_info_by_order_id_ComponentContextService,
) { 
    super();
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  initialized = false;

  async $init() {
    this.title = 'integration_info_by_order_id';
  
    const $form = this;
    const $utils = this.$utils;

    
    
    
    
    
    
    
    
    
    
    
    

    await this.on_init();

    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
    this.$formGroupFieldValidationObservables
      .IntegrationHubId
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .IntegrationHubSourceId
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .IntegrationHubSourceLookupCode
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .IntegrationHubSourcePlatform
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .In_Type
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .In_CreatedSysDateTime
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .In_IntegrationId
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .In_TransactionId
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .In_Notes
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .Out_Type
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .Out_CreatedSysDateTime
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .Out_IntegrationId
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .Out_TransactionId
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .Out_Notes
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
  }

  close() {
    this.$finish.emit();
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }
 
  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $form: FootprintManager_integration_info_by_order_idComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_integration_info_by_order_id_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/05/2024
  
  $form.title = `Integration information for order id ${$form.inParams.order_id}`
  
  let integration_info = (await $flows.FootprintManager.get_integration_info_by_order_id({ order_id: $form.inParams.order_id }));
  
  if ($utils.isDefined(integration_info)) {
  
      $form.fieldsets.integration_hub.hidden = true;
      $form.fields.IntegrationHubId.hidden = true;
      $form.fields.IntegrationHubSourceId.hidden = true;
      $form.fields.IntegrationHubSourceLookupCode.hidden = true;
      $form.fields.IntegrationHubSourcePlatform.hidden = true;
  
      if (integration_info.IntegrationHubId !== "") {
          $form.fieldsets.integration_hub.hidden = false;
          $form.fields.IntegrationHubId.hidden = false;
          $form.fields.IntegrationHubId.control.value = integration_info.IntegrationHubId;
      }
  
      if (integration_info.IntegrationHubSourceId !== "") {
          $form.fieldsets.integration_hub.hidden = false;
          $form.fields.IntegrationHubSourceId.hidden = false;
          $form.fields.IntegrationHubSourceId.control.value = integration_info.IntegrationHubSourceId;
      }
  
      if (integration_info.IntegrationHubSourceLookupCode !== "") {
          $form.fieldsets.integration_hub.hidden = false;
          $form.fields.IntegrationHubSourceLookupCode.hidden = false;
          $form.fields.IntegrationHubSourceLookupCode.control.value = integration_info.IntegrationHubSourceLookupCode;
      }
  
      if (integration_info.IntegrationHubSourcePlatform !== "") {
          $form.fieldsets.integration_hub.hidden = false;
          $form.fields.IntegrationHubSourcePlatform.hidden = false;
          $form.fields.IntegrationHubSourcePlatform.control.value = integration_info.IntegrationHubSourcePlatform;
      }
  
      $form.fieldsets.inbound_transmission.hidden = true;
      $form.fields.In_CreatedSysDateTime.hidden = true;
      $form.fields.In_IntegrationId.hidden = true;
      $form.fields.In_Notes.hidden = true;
      $form.fields.In_Payload_Json.hidden = true;
      $form.fields.In_Payload_Xml.hidden = true;
      $form.fields.In_TransactionId.hidden = true;
      $form.fields.In_Type.hidden = true;
  
      let Inbounds = integration_info.WavelengthConnectorTransmissions?.filter(t => t.Direction?.toUpperCase() === "IN")
  
      if ($utils.isDefined(Inbounds)) {
  
          Inbounds = Inbounds.sort((a, b) => new Date(b.CreatedSysDateTime).getTime() - new Date(a.CreatedSysDateTime).getTime());; //Sort newest to oldest
  
          let Inbound = Inbounds[0]; //Get the oldest record
  
          $form.fieldsets.inbound_transmission.hidden = false;
  
          $form.fields.In_CreatedSysDateTime.hidden = false;
          $form.fields.In_IntegrationId.hidden = false;
          $form.fields.In_TransactionId.hidden = false;
          $form.fields.In_Type.hidden = false;
  
          $form.fields.In_CreatedSysDateTime.control.value = Inbound.CreatedSysDateTime;
          $form.fields.In_IntegrationId.control.value = Inbound.IntegrationId.toUpperCase();
          $form.fields.In_TransactionId.control.value = Inbound.TransactionId.toUpperCase();
          $form.fields.In_Type.control.value = `${Inbound.Type}${(Inbounds.length > 1) ? ` (${Inbounds.length} records)` : ``}`;
  
          let payload = Inbound.Notes;
  
          if ($utils.isDefined(payload)) {
  
              try {
  
                  payload = payload.trim();
  
                  if (is_json(payload)) {
                      $form.fields.In_Payload_Json.control.value = JSON.parse(payload);
                      $form.fields.In_Payload_Json.hidden = false;
                  } else if (is_xml(payload)) {
                      $form.fields.In_Payload_Xml.control.value = $utils.parseXml(payload);
                      $form.fields.In_Payload_Xml.hidden = false;
                  } else {
                      $form.fields.In_Notes.control.value = payload;
                      $form.fields.In_Notes.hidden = false;
                  }
  
              } catch (e) {
                  $form.fields.In_Notes.control.value = payload;
                  $form.fields.In_Payload_Json.hidden = true;
                  $form.fields.In_Payload_Xml.hidden = true;
                  $form.fields.In_Notes.hidden = false;
              }
          }
      }
  
      $form.fieldsets.outbound_transmission.hidden = true;
      $form.fields.Out_CreatedSysDateTime.hidden = true;
      $form.fields.Out_IntegrationId.hidden = true;
      $form.fields.Out_Notes.hidden = true;
      $form.fields.Out_Payload_Json.hidden = true;
      $form.fields.Out_Payload_Xml.hidden = true;
      $form.fields.Out_TransactionId.hidden = true;
      $form.fields.Out_Type.hidden = true;
      $form.fields.Out_Delete.hidden = true;
  
      let Outbounds = integration_info.WavelengthConnectorTransmissions.filter(t => t.Direction?.toUpperCase() === "OUT");
  
      if ($utils.isDefined(Outbounds)) {
  
          Outbounds = Outbounds.sort((a, b) => new Date(b.CreatedSysDateTime).getTime() - new Date(a.CreatedSysDateTime).getTime());; //Sort newest to oldest
  
          let Outbound = Outbounds[0]; //Get the oldest record
  
          $form.fieldsets.outbound_transmission.hidden = false;
  
          $form.fields.Out_CreatedSysDateTime.hidden = false;
          $form.fields.Out_IntegrationId.hidden = false;
          $form.fields.Out_TransactionId.hidden = false;
          $form.fields.Out_Type.hidden = false;
          $form.fields.Out_Delete.hidden = false;
  
          $form.vars.outbound_transactions = Outbounds.map(o => {
              return {
                  transaction_id: o.TransactionId,
                  transmission_id: o.Id,
                  entity: o.Entity
              }
          })
  
          $form.fields.Out_CreatedSysDateTime.control.value = Outbound.CreatedSysDateTime;
          $form.fields.Out_IntegrationId.control.value = Outbound.IntegrationId.toUpperCase();
          $form.fields.Out_TransactionId.control.value = Outbound.TransactionId.toUpperCase();
          $form.fields.Out_Type.control.value = `${Outbound.Type}${(Outbounds.length > 1) ? ` (${Outbounds.length} records)` : ``}`;
  
          let payload = Outbound.Notes;
  
          if ($utils.isDefined(payload)) {
  
              try {
  
                  payload = payload.trim();
  
                  if (is_json(payload)) {
                      $form.fields.Out_Payload_Json.control.value = JSON.parse(payload);
                      $form.fields.Out_Payload_Json.hidden = false;
                  } else if (is_xml(payload)) {
                      $form.fields.Out_Payload_Xml.control.value = $utils.parseXml(payload);
                      $form.fields.Out_Payload_Xml.hidden = false;
                  } else {
                      $form.fields.Out_Notes.control.value = payload;
                      $form.fields.Out_Notes.hidden = false;
                  }
  
              } catch (e) {
                  $form.fields.Out_Notes.control.value = payload;
                  $form.fields.Out_Payload_Json.hidden = true;
                  $form.fields.Out_Payload_Xml.hidden = true;
                  $form.fields.Out_Notes.hidden = false;
              }
          }
      }
  }
  
  function is_xml(payload: any) {
      let payload_string: string = payload;
      let is_xml: boolean = false;
      let payload_xml: any;
  
      try {
          if (payload_string.startsWith("<") && payload_string.endsWith(">")) {
              payload_xml = $utils.parseXml(payload_string)
              if ($utils.isDefined(payload_xml)) {
                  is_xml = true;
              };
          };
      } catch (e) { }
      return is_xml;
  }
  
  function is_json(payload: any) {
      let payload_string: string = payload;
      let is_json: boolean = false;
      let payload_json: any;
  
      try {
          payload_string = payload_string.trim();
          payload_json = JSON.parse(payload_string);
          if ($utils.isDefined(payload_json)) {
              is_json = true;
          }
      } catch (e) { }
      return is_json;
  }
  }
  on_out_delete(event = null) {
    return this.on_out_deleteInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_out_deleteInternal(
    $form: FootprintManager_integration_info_by_order_idComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_integration_info_by_order_id_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/05/2024
  
  if ($utils.isDefined($form.vars.outbound_transactions)) {
  
      let count: number = 0;
  
      try {
  
          for (let outbound_transaction of $form.vars.outbound_transactions) {
  
              if (outbound_transaction.entity === `Order`) {
                  await $flows.Utilities.crud_delete_flow({ entitySet: 'WavelengthConnectorOrderTransmissions', id: outbound_transaction.transmission_id });
              } else if (outbound_transaction.entity === `Shipment`) {
                  await $flows.Utilities.crud_delete_flow({ entitySet: 'WavelengthConnectorShipmentTransmissions', id: outbound_transaction.transmission_id });
              }
  
              count++;
          }
  
          await $shell.FootprintManager.openInfoDialog(`Success`, `Deleted ${count} record(s).`)
  
      } catch (error) {
  
          let targetError = error;
          while ($utils.isDefined(targetError?.error)) { targetError = targetError.error };
          if (typeof targetError === "string") { targetError = { "message": targetError } };
          if (!$utils.isDefined(targetError?.message)) { targetError = { "message": `Uncaught exception ${JSON.stringify(targetError)}` } };
  
          await $shell.FootprintManager.openErrorDialog(`Error`, targetError?.message)
      }
  
      await $form.on_init();
  }
  }
  //#endregion private flows
}
